<template>
    <div style="padding: 2rem 3rem; text-align: left;">
        <div class="field">
            <b-form-group label="Device Installation Address Line 1:" label-for="create-installation-address-line1">
                <b-form-input id="create-installation-address-line1" v-model="model.address.line_1" type="text"
                    required />
            </b-form-group>

            <b-form-group label="Device Installation Address Line 2:" label-for="create-installation-address-line2">
                <b-form-input id="create-installation-address-line2" v-model="model.address.line_2" type="text"
                    required />
            </b-form-group>

            <b-form-group label="City:" label-for="create-installation-address-city">
                <b-form-input id="create-installation-address-city" v-model="model.address.city" type="text" required />
            </b-form-group>

            <b-form-group label="State:" label-for="create-installation-address-state">
                <b-form-select v-model="model.address.state" :options="stateOptions"
                    id="create-installation-address-state" required />
            </b-form-group>

            <b-form-group label="Zip Code:" label-for="create-installation-address-zip">
                <b-form-input id="create-installation-address-zip" v-model="model.address.zip" type="text" required />
            </b-form-group>
        </div>
    </div>
</template>

<script>

    import { stateOptions } from '../../config/address'
    export default {
        props: {
            model:{ type: Object }
        },

        data(){
            return{
                stateOptions: stateOptions
            }
        },

        mounted(){ this.$emit('can-continue', {value: true}) }
    }

</script>
